import { Card, Descriptions, Divider, Text, Title } from '@bancobarigui/barihaus';
import { InspectionItemPayload } from '@/services/types/inspection.types';

interface ItemsSectionProps {
  items: InspectionItemPayload[];
}

export function ItemsSection({ items }: ItemsSectionProps) {
  return (
    <Card className="shadow-sm">
      <Title level={4} className="mb-4">
        Itens da Inspeção
      </Title>
      {items && items.length > 0 ? (
        <div className="space-y-4">
          {items.map((item, index) => (
            <div key={index} className="border rounded-lg p-4 bg-gray-50">
              <div className="mb-3">
                <Text strong className="text-lg">
                  Item {index + 1}
                </Text>
              </div>
              <Descriptions
                column={{ xs: 1, sm: 2 }}
                size="small"
                items={[
                  {
                    key: 'address',
                    label: <Text strong>Endereço</Text>,
                    children: `${item.street}, ${item.number}${item.complement ? ' - ' + item.complement : ''} - ${item.district}, ${item.city}/${item.state}`,
                    span: 2,
                  },
                  {
                    key: 'cep',
                    label: <Text strong>CEP</Text>,
                    children: item.cep || '-',
                  },
                  {
                    key: 'inspectionType',
                    label: <Text strong>Tipo de Inspeção</Text>,
                    children: item.inspectionTypeName || '-',
                  },
                  {
                    key: 'inspectionReason',
                    label: <Text strong>Motivo</Text>,
                    children: item.inspectionReasonName || '-',
                  },
                  {
                    key: 'iptu',
                    label: <Text strong>IPTU</Text>,
                    children: item.iptuNumber || '-',
                  },
                  {
                    key: 'registrationNumber',
                    label: <Text strong>N° Matrícula</Text>,
                    children: item.registrationNumber || '-',
                  },
                  {
                    key: 'registryOfficeNumber',
                    label: <Text strong>N° Cartório</Text>,
                    children: item.registryOfficeNumber || '-',
                  },
                  {
                    key: 'landArea',
                    label: <Text strong>Área do Terreno</Text>,
                    children: item.landArea ? `${item.landArea} m²` : '-',
                  },
                  {
                    key: 'builtArea',
                    label: <Text strong>Área Construída</Text>,
                    children: item.builtArea ? `${item.builtArea} m²` : '-',
                  },
                  {
                    key: 'privateArea',
                    label: <Text strong>Área Privativa</Text>,
                    children: item.privateArea ? `${item.privateArea} m²` : '-',
                  },
                  {
                    key: 'observation',
                    label: <Text strong>Observações</Text>,
                    children: item.observation || '-',
                    span: 2,
                  },
                ]}
              />
              {item.contacts && item.contacts.length > 0 && (
                <>
                  <Divider className="my-3" />
                  <div>
                    <Text strong className="block mb-2">
                      Contatos:
                    </Text>
                    <div className="space-y-2">
                      {item.contacts.map((contact, cIndex) => (
                        <div key={cIndex} className="pl-4 border-l-2 border-gray-300">
                          <Text>
                            <strong>{contact.contactName}</strong> - {contact.email}
                            {contact.mobilePhone && ` | Celular: ${contact.mobilePhone}`}
                          </Text>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      ) : (
        <Text className="text-gray-500">Nenhum item cadastrado</Text>
      )}
    </Card>
  );
}
